import { useMemo } from 'react';

import { useRouterState, type NavigateOptions } from '@mint/routing';
import isMobile from 'is-mobile';
import { useAtom } from 'jotai';

import { agenticAiChatActiveAtom } from '../store/index.js';

const forbiddenAgenticAiPages: NavigateOptions['to'][] = [
  '/company-profile',
  '/ai-hub',
];

const getIsAgenticAiAllowed = (pathname: string) => {
  return !forbiddenAgenticAiPages.some(
    (path) => path && pathname.startsWith(path),
  );
};

const useAgenticModal = () => {
  const currentPathname = useRouterState({
    select: (state) => state.location.pathname,
  });
  const isMobileDevice = isMobile();
  const [isChatManuallyActive, setIsChatManuallyActive] = useAtom(
    agenticAiChatActiveAtom,
  );

  const isAgenticAiAvailable =
    getIsAgenticAiAllowed(currentPathname) && !isMobileDevice;

  const isChatActive = useMemo(
    () => isChatManuallyActive && isAgenticAiAvailable,
    [isChatManuallyActive, isAgenticAiAvailable],
  );

  return {
    currentPathname,
    isAgenticAiAvailable,
    isChatActive,
    setIsChatManuallyActive,
  };
};

export default useAgenticModal;
